const frontend = 'https://www.epicsoft.nl';
const backend = 'https://backend.epicsoft.nl';

export const environment = {
	production: true,
	test: false,
	backend: {
		server: backend,
		api: `${backend}/api`
	},
	frontend: {
		server: frontend
	}
};
